import { AGUAppModuleDefinition } from '../../app-surface/app-module-definition';

/**
 * The text one module shows in the sidebar rail.
 *
 * `NavLabel` exists because the rail wants a shorter word than the page title —
 * the mockup's rail reads 'Grants' and 'Jobs' where the modules are titled
 * 'Grant Finder' and 'Job Finder' — and most modules never need it, so it is
 * optional and falls back to `Title`.
 *
 * A blank `NavLabel` is treated as absent rather than honoured: an empty string
 * is always an authoring slip, and honouring it would render a nav row with an
 * icon and no name, which is exactly the kind of failure nobody sees in a diff.
 *
 * A pure function rather than a component method so it can be unit-tested
 * directly — this package has no TestBed (see app-sidebar.component.spec.ts).
 */
export function SidebarNavLabel(module: Pick<AGUAppModuleDefinition, 'NavLabel' | 'Title'>): string {
    const label = module.NavLabel?.trim() ?? '';
    return label.length > 0 ? label : module.Title;
}
